import countries from "../helpers/avs-countries";
import states from "../helpers/avs-states";

const StateGroup = ({ country }) => {
  const groupStates = country
    ? states.filter(state => state.country === country)
    : states;

  return (
    <>
      {groupStates.map(({ abbreviation, iso_3166, name }) => (
        <option
          key={iso_3166}
          value={abbreviation}
        >{name}</option>
      ))}
    </>
  );
};

const StateInput = (props) => {
  const {
    country,
    placeholder,
    ...selectProps
  } = props;

  return (
    <select {...selectProps}>
      <option value="">{placeholder || ""}</option>
      {country
        ? <StateGroup country={country} />
        : countries.map(({ abbreviation, alpha_3_code, name }) => (
          <optgroup key={alpha_3_code} label={name}>
            <StateGroup country={abbreviation} />
          </optgroup>
        ))
      }
    </select>
  );
}

export default StateInput;
